import {TaskResponse} from './task-response';

export class CreditExceptionTaskResponse extends TaskResponse {

  comment!: string;
  exceptionResponse!: string;

}

